/**
 * nav.ro frontend entry point — bundle-uit de Vite la public/build/assets/js/app-<hash>.js
 *
 * Ordine de incarcare in browser:
 *   1) common.min.js (defer) → Resort framework + globale ($, device) — LEGACY
 *   2) Per-page *.min.js (defer) → folosesc Resort + Swiper legacy
 *   3) app bundle (type=module) → ruleaza dupa defer; coexista cu legacy
 *
 * Strategy de migrare:
 *   - Modulele core/* re-definesc Node.prototype.on / off / find / etc. cu
 *     implementare IDENTICA cu legacy. Idempotent — ultimul wins.
 *   - Cand totul testeaza OK, scoatem <script src="common.min.js"> din header.php.
 */

// Vendor libs din npm — DISPONIBILE prin import {} from 'swiper'/'nouislider'
// pentru codul nou TS. NU sunt bundle-uite global pentru ca legacy per-page
// scripts (home.js, etc.) folosesc /js/swiper.min.js Swiper 6 cu API diferit
// (`.swiper-container` vs `.swiper`). Cand migram per-page, importam aici.
// import './vendor/swiper.js';     // disponibil cand migram per-page
// import './vendor/nouislider.js'; // disponibil cand migram per-page

// Resort framework core — re-definesc Node.prototype.* identic cu legacy.
import './core/util.js';        // isset / isfn / trigger / each / window.each
import './core/selector.js';    // window.$
import './core/device.js';      // window.device
import './core/style.js';       // css / offset / data / removeData / html / text / val / getProp / dxGetProp
import './core/dom.js';         // find / findChildren / index / siblings / next / prev / parents / NodeList.filter
import './core/events.js';      // on / off / trigger + customEvents.swipe + window.on/off
import './core/anim.js';        // slideDown / slideUp / slideToggle + dxFadeIn / dxFadeOut
import './core/resort.js';      // Resort class + window.Resort

// Widgets — Node.prototype extensions per page.
import './widgets/navmenu.js';  // navMenu (testi-group, layer-3 pagination)
import './widgets/tooltip.js';  // Tooltip (data-tooltip)
import './widgets/popup.js';    // popupBox (.popup-box siblings)

// Form classes — FormValidator + Form (cu native-fix integrat).
import './form/validator.js';   // FormValidator + Node.prototype.FormValidator
import './form/form.js';        // Form + Node.prototype.Form

// CSS-uri pentru librarii — comentate cat timp legacy *.min.css inca sunt
// incarcate. Decomentate per pagina cand migram.
// import 'swiper/css';
// import 'swiper/css/navigation';
// import 'swiper/css/pagination';
// import 'nouislider/dist/nouislider.css';

// Altcha CAPTCHA web component — registers <altcha-widget>. PERF-3: imported
// DYNAMICALLY and only on pages that actually render the widget, so the ~14 KB
// bundle stays off the ~280 form-less pages. app.ts is a deferred module, so it
// runs after the DOM is parsed → the query sees the server-rendered widget.
//
// PERF-REFLOW-ALTCHA: the import is additionally deferred to the first idle
// slice after load. Importing at app.ts time upgraded the element MID-LOAD, and
// the widget's mount reads layout (getBoundingClientRect) before the browser's
// first layout ever ran — a forced synchronous layout of the whole page (the
// console's "[Violation] Forced reflow" — 350ms on /colocare under 4x CPU
// throttle). After first paint the layout is clean, so the same reads cost ~0.
// Visibility gating (IntersectionObserver) is NOT an option here: the widget is
// display:none by design (ALTCHA-INVISIBLE-1 in new.index.min.css) so it never
// intersects. auto="onload" semantics are preserved — the PoW still solves
// unprompted, just one idle slice later, still seconds before any human can
// fill a form. The 2.5s timeout bounds the wait on busy pages; no rIC support
// (Safari < 15.4) → plain timer past first paint.
if (document.querySelector('altcha-widget')) {
    const importAltcha = () => { void import('altcha'); };
    if (typeof requestIdleCallback === 'function') {
        requestIdleCallback(importAltcha, { timeout: 2500 });
    } else {
        setTimeout(importAltcha, 300);
    }
}

// Bootstrap — `new Resort(rt => {...})` care lega init modules per-pagina.
// Inlocuieste callback-ul final din legacy common.min.js.
import { startResortBootstrap } from './init/bootstrap.js';
startResortBootstrap();

if (import.meta.env.DEV) {
    console.log('[nav] dev mode — Vite HMR active');
}
